import { ISvgInfo } from '../types';

export const svgConfig: ISvgInfo = {
    rect: {
        shape: '矩形',
        x: 0,
        y: 0,
        width: 250,
        height: 140,
        rx: 0,
        ry: 0,
        fill: '#6BF6F5ff',
        stroke: '#2B7BF7ff',
        'stroke-width': 5,
    },
    ellipse: {
        cx: 0,
        cy: 0,
        shape: '椭圆',
        rx: 200,
        ry: 100,
        fill: '#6BF6F5ff',
        stroke: '#2B7BF7ff',
        'stroke-width': 5,
    },
    line: {
        shape: '直线',
        x1: 10,
        y1: 10,
        x2: 100,
        y2: 100,
        fill: '#6BF6F5ff',
        stroke: '#6BF6F5ff',
        'stroke-width': 5,
    },
};
